export default __webpack_public_path__ + "static/media/mainBackground.d462103c.gif";